export const hicTemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.general.project' },
  { header: 'generateReport.dataToResult.report.test.hic.lot_id' },
  { header: 'generateReport.dataToResult.report.test.hic.status' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.test.hic.tipo_teste_amostra' },
  { header: 'generateReport.dataToResult.report.test.hic.id_numeric' },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.firma_insp' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.test.hic.quality_plan' },
  { header: 'generateReport.dataToResult.report.test.hic.data_entrada' },
  { header: 'generateReport.dataToResult.report.test.hic.data_saida' },
  { header: 'generateReport.dataToResult.report.test.hic.solucao' },
  { header: 'generateReport.dataToResult.report.test.hic.lote_solucao' },
  { header: 'generateReport.dataToResult.report.test.hic.cuba_teste' },
  { header: 'generateReport.dataToResult.report.test.hic.capela_teste' },
  { header: 'generateReport.dataToResult.report.test.hic.ph_antes_saturacao' },
  { header: 'generateReport.dataToResult.report.test.hic.ph_inicial_teste' },
  { header: 'generateReport.dataToResult.report.test.hic.ph_final' },
  {
    header:
      'generateReport.dataToResult.report.test.hic.concentracao_h2s_inicial',
  },
  {
    header:
      'generateReport.dataToResult.report.test.hic.concentracao_h2s_final',
  },
  { header: 'generateReport.dataToResult.report.test.hic.gas_inerte_purga' },
  { header: 'generateReport.dataToResult.report.test.hic.gas_de_teste' },
  { header: 'generateReport.dataToResult.report.test.hic.cp' },
  { header: 'generateReport.dataToResult.report.test.hic.csrref' },
  { header: 'generateReport.dataToResult.report.test.hic.csrmedia' },
  { header: 'generateReport.dataToResult.report.test.hic.clrref' },
  { header: 'generateReport.dataToResult.report.test.hic.clrmedia' },
  { header: 'generateReport.dataToResult.report.test.hic.ctrref' },
  { header: 'generateReport.dataToResult.report.test.hic.ctrmedia' },
  { header: 'generateReport.dataToResult.report.test.hic.grau_mes' },
  { header: 'generateReport.dataToResult.report.test.hic.bitola' },
  { header: 'generateReport.dataToResult.report.test.hic.orientacao' },
  { header: 'generateReport.dataToResult.report.test.hic.ordem' },
  { header: 'generateReport.dataToResult.report.test.hic.control_lot' },
  { header: 'generateReport.dataToResult.report.test.hic.corrida' },
  { header: 'generateReport.dataToResult.report.test.hic.ippn' },
  { header: 'generateReport.dataToResult.report.test.hic.lote_tt' },
  { header: 'generateReport.dataToResult.report.test.hic.observacoes' },
]
